export default __webpack_public_path__ + "static/media/2.23ace01e.jpg";